import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import "./AppHeader.scss";
import { Layout, Menu, Dropdown, Icon, Button, Modal, Form, Input } from "antd";

import ProfileIcon from "icons/ProfileIcon";
import WhatsappIcon from "icons/WhatsappIcon";
import DownArrowIcon from "icons/DownArrowIcon";
import BrdgxIcon from "icons/BrdgxIcon";
import EnterOTPLayout from "components/EnterOTPLayout";
import EnterPhoneNumberLayout from "components/EnterPhoneNumberLayout";
import OkModal from "../modal/OkModal";
import SignUpModal from "../modal/SignUpModal";
import {
    login,
    getCurrentCustomer,
    submitPhoneNumber,
    submitOTP, switchSession, generateAuthyFactor, verifyAuthyFactor
} from "api/api";
import {displayError, displayGenericError} from "common/notifications";
import ChangePasswordModal from "../settings/ChangePasswordModal";
import {validatePassword} from "../../utils/utils";
import {changePassword, changePasswordInFirstTime} from "../../api/api";
import {displaySuccessMessage} from "../../common/notifications";

import { FormattedMessage } from "react-intl";
import {connect, useDispatch} from "react-redux";
import {loginSuccess, USER_LOGIN_SUCCESS} from "../../rx/user/userAction";
import withUseIntl from "../withUseIntl";

import config from "../../config";
import QRCode from "react-qr-code";
import OtpInput from "react-otp-input";

const Header = Layout.Header;
const { Password } = Input;

class AppHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      email: "",
      password: "",
      error: false,
      errorMessage: "",
      okVisible: false,
      signupVisible: false,
      showChangePasswordModal:false,
        loginRequest:null,
    }
  }

  handleMenuClick = ({ key }) => {
    if (key === "logout") {
      this.props.onLogout();
    }
      else if (key === "switchAccount") {
        switchSession( localStorage.getItem("ACCESS_TOKEN")).then(response=>{
            localStorage.setItem("ACCESS_TOKEN", response.accessToken);
            window.location.href= "/";
        }).catch(error=>{
            if(error.status === 401){
                localStorage.removeItem("ACCESS_TOKEN");
            }
            displayGenericError(error)
        })
      }
  };

  handleCloseLoginModal = () => {
    this.setState({visible: false});
  };

  handleCloseSignupModal = () => {
    this.setState({signupVisible: false});
  };

  handleOpenSignupModal = () => {
    this.setState({signupVisible: true, visible: false});
  };

  handleOk = () => {
    const { history } = this.props;
    this.setState({
      signupVisible:false,
      okVisible:false
    })
    history.push("/login?hide-signup-modal=true");
  };

  handleSignup = () => {
    this.setState({
      signupVisible:false,
      okVisible:true
    })
  };

  render() {
    let menuItems;
    const { currentCustomer } = this.props;
      let location = this.props.location;
      const { pathname } = location ? location : {pathname: ''};
    const isLogin = pathname === "/login";
    const AntWrappedLoginForm = Form.create()(LoginFormModal);
    if (
      currentCustomer &&
      currentCustomer.loginStatus !== "EMAIL_VERIFICATION_REQUIRED"
    ) {
      menuItems = [
        <Menu.Item key="/profile" className="profile-menu">
          <ProfileDropdownMenu
            currentCustomer={currentCustomer}
            handleMenuClick={this.handleMenuClick}
          />
        </Menu.Item>
      ];
    } else {
      menuItems = [
        <Menu.Item className={"none-login-item"} key="/login">
          <span className={"copy"}>
            {isLogin ? "Don't have an account?" : "Already have an account?"}
          </span>

          {isLogin ? (
            <Button
              htmlType={"button"}
              type="primary"
              size={"small"}
              className={"login-button"}
              onClick={this.handleOpenSignupModal}
            >
              Sign Up
            </Button>
          ) : (
            <Button
              htmlType={"button"}
              type="primary"
              size={"small"}
              className={"login-button"}
              onClick={() => {
                this.setState({ visible: true });
              }}
            >
              Log In
            </Button>
          )}
        </Menu.Item>
      ];
    }

    var headerColor={};
    if (config.env === 'uat') {
      headerColor.color = 'blue';
    } else if (config.env === 'development') {
      headerColor.color = 'red';
    } else {
      headerColor.color = 'black';
    } 

    return (
      <Header className="app-header">
        {this.props.currentCustomer ? (
          <>
          <Link to="/" className="app-logo">
            <BrdgxIcon />
          </Link>
          <div style={{fontSize: "18px"}}><b style={headerColor}>{config.header}</b></div>
          </>
        ): (
          <a href="https://brdgx.com/" className="app-logo">
            <BrdgxIcon />
          </a>
        )}

        <Menu
          className="app-menu"
          mode="horizontal"
          selectedKeys={[location ? location.pathname : {pathname:''} ]}
        >
          {menuItems}
        </Menu>

        <Modal
          className={"sign-in-modal"}
          title="Sign in to your account"
          visible={this.state.visible}
          onCancel={() => this.setState({ visible: false })}
          maskClosable={false}
          footer={null}
          style={{ top: 80 }}
          width={340}
        >
          <AntWrappedLoginForm onClose={() => this.handleCloseLoginModal()}  handleOpenSignupModal={this.handleOpenSignupModal}/>
        </Modal>

        <OkModal
          message="Please verify your email address."
          visible={this.state.okVisible}
          handleOk={this.handleOk}
          title="Confirmation email is sent"
        />
        <SignUpModal
          visible={this.state.signupVisible}
          handleOk={this.handleSignup}
          onCancel={this.handleCloseSignupModal}
          title="Sign Up"
        />
      </Header>
    );
  }
}

class LoginFormModal extends Component {
  state = {
    customer: {},
    otpVisible: false,
    isNoError: true,
    errorMessage:'',
      qrValue:"",
      qrCodeVisible:false,
      otp:""
  };

  handleSubmitPhoneNumber = ({ phoneNumber, countryCode }) => {
    submitPhoneNumber(
      {
        phone: phoneNumber,
        country: countryCode,
          email:this.state.loginRequest.email,
          password:this.state.loginRequest.password,
      },
      this.token
    )
      .then(() =>
        this.setState({
          customer: {
            ...this.state.customer,
            loginStatus: "PHONE_VERIFICATION_REQUIRED",
            phone: phoneNumber
          }
        })
      )
      .catch(displayGenericError);
  };

  handleSubmitOTP = otp => {
      let props = this.props;
    submitOTP(otp, null, this.token, this.state.loginRequest.email, this.state.loginRequest.password)
      .then(response => {
        if (response.result === "success") {
            let roleResources = this.state.customer.roleResources;
            let isReadOnly=false;
            if(roleResources && roleResources.length>0 && roleResources.find(item => item.name=="READONLY")) {
                isReadOnly = true;
            }
          localStorage.setItem("ACCESS_TOKEN", response.content);
          getCurrentCustomer()
              .then(customer => {
                  // props.pushCurrentUser({
                  //     type: USER_LOGIN_SUCCESS,
                  //     currentUser: customer,
                  // })
                  if(customer.firstLogin && customer.userType !== 'ONLINE_NF2F'){
                      this.setState({
                          otpVisible: true,
                          customer,
                          showChangePasswordModal: customer.firstLogin
                      });
                  }else if(isReadOnly){
                      window.location = "/pages/dashboard";
                  }else{
                      window.location = "/";
                  }

              })
              .catch(displayGenericError);


        } else {
          displayGenericError({ message: response.result });
        }
      })
      .catch(displayGenericError);
  };
  handleOpenSignupModal = () =>{
    this.props.handleOpenSignupModal();
  }
  hideChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: false });
  };
  onChangePassword = value => {
    value.currentPassword = this.state.password;


    const { password, passwordVerification } = value;
    if (
        !validatePassword(password) ||
        !validatePassword(passwordVerification)
    ) {
      displayGenericError({
        message:
            "Your password must be have at least 8 characters with 1 uppercase and 1 lowercase"
      });
      return;
    }
    changePasswordInFirstTime(value)
        .then(() => {
          getCurrentCustomer()
              .then(customer => {
                displaySuccessMessage("You have change password success!")
                  window.location = "/";
              })
              .catch(displayGenericError);
        })
        .catch(displayGenericError);
  }
    generateAuthyQRCode =()=>{
        generateAuthyFactor({ email:this.state.loginRequest.email,
            password:this.state.loginRequest.password }).then(response=>{
            this.setState({
                qrValue:response.content,
                qrCodeVisible: true
            })
        }).catch(error=>{
            displayGenericError(error)
        })
    }
    closeQRModal = ()=>{
        this.setState({
            qrCodeVisible: false
        })
    }
    verifyFactor = ()=>{
        verifyAuthyFactor({
            email: this.state.loginRequest.email,
            password: this.state.loginRequest.password,
            otp: this.state.otp
        }).then(r =>{

            if(r.result ==='success'){
                displaySuccessMessage("Verified App is ok, Please, Enter Otp code bellow");
                this.setState({
                    otp: ""
                })
                localStorage.setItem("ACCESS_TOKEN", r.content);
                this.closeQRModal();
                let roleResources = this.state.customer.roleResources;
                let isReadOnly=false;
                if(roleResources && roleResources.length>0 && roleResources.find(item => item.name=="READONLY")) {
                    isReadOnly = true;
                }
                getCurrentCustomer()
                    .then(customer => {
                        if(customer.firstLogin && customer.userType !== 'ONLINE_NF2F'){
                            this.setState({
                                otpVisible: true,
                                customer,
                                showChangePasswordModal: customer.firstLogin
                            });
                        }else if (isReadOnly){
                            window.location = "/pages/dashboard";
                        }else{
                            window.location = "/";
                        }

                    })
                    .catch(displayGenericError);
            }else{
                displayError("Otp is not correct")
            }
        }).catch(error => {
            displayError(error)
        })
    }
  handleSubmit = event => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const loginRequest = Object.assign({}, values);
        login(loginRequest)
          .then(response => {
            const token = response.accessToken;
            // save token for saving to local storage later
           // this.token = token;

              if (response.loginStatus !== "EMAIL_VERIFICATION_REQUIRED") {
                  this.setState({ otpVisible: true, customer : response, loginRequest:loginRequest});
                  // localStorage.setItem("ACCESS_TOKEN", this.token);
                  // window.location = "/";

                  // this.props.pushCurrentUser({
                  //     type: USER_LOGIN_SUCCESS,
                  //     currentCustomer: response,
                  // })

              } else {
                  // displayGenericError({
                  //   message: "Please confirm your email to login"
                  // });
                  this.setState({
                      isNoError:false,
                      errorMessage:"Please confirm your email to login"
                  })
              }

            // getCurrentCustomer(token)
            //   .then(customer => {
            //     if (customer.loginStatus !== "EMAIL_VERIFICATION_REQUIRED") {
            //       this.setState({ otpVisible: true, customer });
            //       // localStorage.setItem("ACCESS_TOKEN", this.token);
            //       // window.location = "/";
            //     } else {
            //       // displayGenericError({
            //       //   message: "Please confirm your email to login"
            //       // });
            //       this.setState({
            //         isNoError:false,
            //         errorMessage:"Please confirm your email to login"
            //       })
            //     }
            //   })
            //   .catch(displayGenericError);
          })
          .catch(error => {
            if (error.status === 401) {
              // displayGenericError({
              //   message:
              //     "Your Email or Password is incorrect. Please try again!"
              // });
              this.setState({
                isNoError:false,
                errorMessage:"Your Email or Password is incorrect. Please try again!"
              })
            } else {
              this.setState({
                isNoError:false,
                errorMessage: error.result
              })
              //displayGenericError(error);
            }
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className={"form-content"}>
            <Form.Item
                validateStatus={this.state.isNoError ? "success" : "error"}
                help={this.state.isNoError ? "" : this.state.errorMessage}>

            </Form.Item>
            <Form.Item label={"Email"}>
              {getFieldDecorator("email", {
                rules: [
                  {
                    required: true,
                    message: "Please enter your email!"
                  }
                ]
              })(<Input size="large" name="email" onChange={()=>{
                this.setState({
                  isNoError: true,
                  errorMessage:''
                })
              }} />)}
            </Form.Item>

            <Form.Item label={"Password"}>
              {getFieldDecorator("password", {
                rules: [
                  {
                    required: true,
                    message: "Please enter your password!"
                  }
                ]
              })(
                <Password
                  size={"large"}
                  type="password"
                  onChange={(e)=>{

                    this.setState({
                      isNoError: true,
                      password:e.target.value,
                      errorMessage:''
                    })
                  }}
                />
              )}
            </Form.Item>
          </div>

          <div className={"login-form-modal-buttons"}>
              <Button
                  htmlType={"button"}
                  type="primary"
                  size={"small"}
                  className={"login-button"}
                  onClick={this.handleOpenSignupModal}
              >
                  Sign Up
              </Button>
            <Button htmlType="submit" type="primary" className="sign-up-button">
              Log In
            </Button>
          </div>
          <div className={"login-form-modal-buttons"}>
              <Link className={"forgot-password-link"} onClick={this.props.onClose} to={"/forgot-password"}>
                  Forgot Password?
              </Link>
            {/*<span className={"signup-link"} onClick={this.handleOpenSignupModal}>Sign Up</span>*/}
          </div>
        </Form>

        <Modal
          wrapClassName="otp-sign-in"
          visible={this.state.otpVisible}
          onCancel={() => this.setState({ otpVisible: false })}
          footer={null}
        >
          {(this.state.customer.loginStatus === "PHONE_NUMBER_REQUIRED" || this.state.customer.loginStatus === "NO_LOGIN" )? (
            <EnterPhoneNumberLayout
              proceedHandler={this.handleSubmitPhoneNumber}
            />
          ) : (
            <EnterOTPLayout
              customer={this.state.customer}
              verifyOTP={this.handleSubmitOTP}
              generateAuthyQRCode={this.generateAuthyQRCode}
              token={this.token}
            />
          )}
        </Modal>
          <Modal  visible={this.state.qrCodeVisible} onOk={this.closeQRModal} onCancel={this.closeQRModal}>
          <div style={{ height: "auto", margin: "0 auto", maxWidth: 512, width: "100%" , marginTop:"3px"}}>
              <QRCode
                  size={512}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" ,  marginTop:"3px"}}
                  value={this.state.qrValue}
                  viewBox={`0 0 512 512`}
              />
          </div>
              <div className="otp-input-section" style={{marginTop:'5px'}}>
                  <span>(Please open TOTP app like Authy, Google Authenticator,...and capture QR code Then input opt number bellow)  </span>
                  <OtpInput
                      shouldAutoFocus={true}
                      numInputs={6}
                      isInputNum={true}
                      containerStyle={{ height: "100%" }}
                      value={this.state.otp}
                      onChange={otp => this.setState({ otp },()=>{
                          if(this.state.otp.length === 6){
                              this.verifyFactor()
                          }
                      })}
                  />
              </div>
          </Modal>
        <ChangePasswordModal
            visible={this.state.showChangePasswordModal}
            onOk={this.onChangePassword}
            hiddenCurrentPasword={true}
            onCancel={this.hideChangePasswordModal}
        />
      </>
    );
  }
}

function ProfileDropdownMenu(props) {
  const dropdownMenu = (
    <Menu onClick={props.handleMenuClick} className="profile-dropdown-menu">
      <Menu.Item key="profile" className="dropdown-item">
        <Link to="/pages/profile" className="nav-text">
          <span className="menu-title"><FormattedMessage id="app.sidebar.manageprofile" /></span>
        </Link>
      </Menu.Item>
        {props.currentCustomer.selfReferenceName && (
            <Menu.Item key="switchAccount" className="dropdown-item">
                <b>{props.currentCustomer.selfReferenceName}</b>
            </Menu.Item>
        )}
      <Menu.Item key="logout" className="dropdown-item">
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <span>
        <a href="https://web.whatsapp.com/send?phone=6591729552&text=Chat with Brdgx business team" target="_blank">
          <Icon component={WhatsappIcon} className="whatsapp-icon" />
        </a>
      </span> 
      <Dropdown
        overlay={dropdownMenu}
        trigger={["click"]}
        getPopupContainer={() =>
          document.getElementsByClassName("profile-menu")[0]
        }
      >
        <span className="ant-dropdown-link">
          <Icon component={ProfileIcon} className="nav-icon" />
          <span className="current-customer-name">
            {props.currentCustomer.name}
          </span>
          <Icon className={"dropdown-icon"} component={DownArrowIcon} />
        </span>
      </Dropdown>
    </>
  );
}

const mapStateToProps = state =>{
    return {
        currentUser: state.user.currentUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        pushCurrentUser: (user) => dispatch (loginSuccess(user))
    }
}

// export default withRouter(AppHeader);
export default withRouter(connect(mapStateToProps, mapDispatchToProps) (withUseIntl(AppHeader)))